import { rd, RemoteData } from '@passionware/monads';
import { ensureError } from '@passionware/platform-js';
import { Skeleton } from 'v5/design-system/Skeleton';
import { ResourceNameWithPronounsConnected } from 'v5/patterns/resource/ResourceNameWithPronouns.connected';

export interface EntityHeaderTitleProps {
  title: RemoteData<string>;
  pronounsOptionId?: number | null;
  resourceTypeId?: number | null;
  /** Shown (muted) when the resolved title is blank. */
  placeholder?: string;
  /** Double-clicking the title, e.g. to edit it; it then selects no word. */
  onDoubleClick?: () => void;
}

export const EntityHeaderTitle = ({
  title,
  pronounsOptionId,
  resourceTypeId,
  placeholder,
  onDoubleClick
}: EntityHeaderTitleProps) => {
  return (
    <div
      className="min-w-0 text-fg-default text-3xl font-semibold [overflow-wrap:anywhere]"
      onMouseDown={
        onDoubleClick &&
        (event => {
          // The second press would select a word under the pointer.
          if (event.detail === 2) event.preventDefault();
        })
      }
      onDoubleClick={onDoubleClick}
    >
      {rd
        .journey(title)
        .wait(<Skeleton className="w-64 h-lh" />)
        .catch(error => (
          <div className="text-4xl font-semibold text-fg-default leading-tight">
            {ensureError(error).message}
          </div>
        ))
        .map(name => (
          <ResourceNameWithPronounsConnected
            name={
              name.trim() || !placeholder ? (
                name
              ) : (
                <span className="text-fg-muted italic">{placeholder}</span>
              )
            }
            pronounsOptionId={pronounsOptionId}
            resourceTypeId={resourceTypeId}
          />
        ))}
    </div>
  );
};
